import {
  Button,
  ButtonGroup,
  Link,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { formatInTimeZone } from "date-fns-tz";
import {
  Link as RouterLink,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { AuthService } from "src/common/AuthService";
import { Loading } from "src/common/Loading";
import { Pagination } from "src/common/Pagination";
import { SortableTh } from "src/common/SortableTh";
import { StaffRole } from "src/common/types";
import { PageContent } from "src/layout/PageContent";
import { PageHeader, PageHeaderTitle } from "src/layout/PageHeader";
import { DealersFilterBar } from "src/routes/Dealers/DealersFilterBar";
import { useDealersQuery } from "src/routes/Dealers/queries";

export const Dealers = () => {
  const navigate = useNavigate();
  const query = useDealersQuery();
  const role = AuthService.hooks.useStaffUserRole();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      <PageHeader
        buttons={
          <ButtonGroup>
            <DealersFilterBar />
            {role === StaffRole.Admin && (
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={() => navigate("/dealers/add")}
              >
                Add
              </Button>
            )}
          </ButtonGroup>
        }
      >
        <PageHeaderTitle>Dealers</PageHeaderTitle>
      </PageHeader>
      {!query.data ? (
        <Loading />
      ) : (
        <PageContent>
          <Table variant="simple">
            <Thead>
              <Tr>
                <SortableTh sortKey="name">Dealer Name</SortableTh>
                <SortableTh sortKey="contactName">Contact Name</SortableTh>
                <SortableTh sortKey="dealerType">Dealer Type</SortableTh>
                <SortableTh sortKey="createdAt">Date Added (GMT)</SortableTh>
              </Tr>
            </Thead>
            <Tbody>
              {query.data.result.map((organization) => (
                <Tr key={organization.dealerOrganizationId}>
                  <Td>
                    <Link
                      as={RouterLink}
                      to={`/dealers/${organization.dealerOrganizationId}`}
                    >
                      <Text>{organization.displayName}</Text>
                    </Link>
                  </Td>
                  <Td>
                    {organization.pointOfContact
                      ? `${organization.pointOfContact.user.firstName} ${organization.pointOfContact.user.lastName}`
                      : "--"}
                  </Td>
                  <Td>{organization.dealerType}</Td>
                  <Td>
                    {formatInTimeZone(
                      organization.createdAt,
                      "GMT",
                      "MM/dd/yyyy"
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Pagination
            unitName="dealer"
            total={query.data.total}
            pageNumber={parseInt(searchParams.get("pageNumber") || "1")}
            pageSize={query.data.pageSize}
            onPageChange={(page) => {
              setSearchParams((prev) => {
                const next = new URLSearchParams(prev);
                next.set("pageNumber", page.toFixed(0));
                return next;
              });
            }}
          />
        </PageContent>
      )}
    </>
  );
};
